import { observer } from 'mobx-react-lite';
import { EventNotificationsEntityIdProvider } from '../../../event-notifications/event-notifications-entity-id-context';
import {
    EventQueueRowData,
    ScheduledEventQueueRowData,
    UnitQueueRowData,
} from '../../../socket/stream-types';
import { getEventQueueRowDataOrScheduledEventQueueRowData } from '../../utils/get-event-queue-row-data';
import { BaseQueueCell } from '../base-queue-cell';

export const ReportingPartyCell = observer(function ReportingPartyCell(props: {
    data: EventQueueRowData | ScheduledEventQueueRowData | UnitQueueRowData;
}) {
    const data = getEventQueueRowDataOrScheduledEventQueueRowData(props.data);
    if (!data?.reportingParty) return null;
    const eventNotificationsEntityId =
        'reportingPartyId' in data ? data.reportingPartyId : undefined;
    return (
        <EventNotificationsEntityIdProvider entityId={eventNotificationsEntityId}>
            <BaseQueueCell>{data.reportingParty}</BaseQueueCell>
        </EventNotificationsEntityIdProvider>
    );
});
